import { render, staticRenderFns } from "./KeyboardSelection.vue?vue&type=template&id=38d32a48&scoped=true&"
import script from "./KeyboardSelection.vue?vue&type=script&lang=js&"
export * from "./KeyboardSelection.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardSelection.vue?vue&type=style&index=0&id=38d32a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d32a48",
  null
  
)

export default component.exports